<template>
  <nav class="navbar" role="navigation">
    <div class="container">
      <div class="navbar-brand">
        <a
          :href="
            `/${
              this.$i18n.locale.split('-')[0] !== 'de'
                ? this.$i18n.locale.split('-')[0]
                : ''
            }`
          "
          class="navbar-item"
          @click.prevent="resetOrderProcess()"
        >
          <div class="header__logo">
            <img alt="Maagtechnic AG" src="@/assets/img/logo.png" />
          </div>
        </a>
        <div class="navbar-item">
          <div
            :class="{ 'is-invisible': !showUploadButton }"
            @click="showFileUpload"
            class="header__upload-area is-mobile-only"
          >
            <img src="@/assets/img/lnr-upload.svg" />
          </div>

          <RouterLink
            v-if="
              screenSize.width < viewports.DESKTOP.minWidth &&
                !showUploadButton &&
                Object.keys(allCartItems).length > 0
            "
            to="/cart"
            class="navbar-item navbar-item--cart is-size-4"
          >
            <SvgIcon
              icon="icon--web-application_cart"
              class="is-primary-dark"
            ></SvgIcon>
            <span class="cart-item-quantity has-text-primary-dark">
              {{ Object.keys(allCartItems).length }}
            </span>
          </RouterLink>
        </div>
        <a
          role="button"
          class="navbar-burger burger"
          @click="toggleMenu"
          :class="{ 'is-active': expanded }"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div
        class="navbar-menu"
        :class="{ 'is-active': expanded }"
        v-if="mainNavigation"
        @click="expanded = false"
      >
        <div class="navbar-end">
          <!--
                    <RouterLink v-for="(navigationLink, index) in mainNavigation" :to="navigationLink.link"
                                v-bind:key="'navigation_main_' + index"
                                class="navbar-item">{{ navigationLink.title }}
                    </RouterLink>
                  -->
          <language-switch />

          <RouterLink
            v-if="Object.keys(allCartItems).length > 0"
            to="/cart"
            class="navbar-item navbar-item--cart is-size-4 mr-5"
          >
            <span class="cart-item-quantity has-text-primary-dark">
              {{ Object.keys(allCartItems).length }}
            </span>
            <SvgIcon
              icon="icon--web-application_cart"
              class="is-primary-dark"
            ></SvgIcon>
          </RouterLink>
          <RouterLink
            :to="isUserLoggedIn ? '/account' : '/login'"
            class="navbar-item is-size-4"
          >
            <SvgIcon
              icon="icon--web-application_user"
              class="is-dark"
              :grow-by-height="true"
            />
            <span
              v-if="
                [viewports.MOBILE.name, viewports.TABLET.name].includes(
                  currentViewport
                )
              "
              class="is-size-5 ml-3"
              >{{ $t("login.mainActions.login") }}</span
            >
          </RouterLink>
          <a v-if="isUserLoggedIn" @click="logout" class="navbar-item">
            Ausloggen
          </a>
          <template
            v-if="
              [viewports.MOBILE.name, viewports.TABLET.name].includes(
                currentViewport
              )
            "
          >
            <RouterLink
              v-for="(navigationLink, index) in topNavigation"
              :to="navigationLink.link"
              v-bind:key="'navigation_main_' + index"
              class="navbar-item"
              >{{ navigationLink.title }}
            </RouterLink>
            <RouterLink
              v-if="Object.keys(allCartItems).length > 0"
              to="/cart"
              class="navbar-item navbar-item--cart is-size-4"
            >
              <SvgIcon
                icon="icon--web-application_cart"
                class="is-light"
              ></SvgIcon>
              <span class="cart-item-quantity has-text-light">
                {{ Object.keys(allCartItems).length }}
              </span>
            </RouterLink>
            <language-switch is-light />
            <business-customer-switch class="navbar-item mb-4 ml-0" />
          </template>
        </div>
      </div>

      <div
        class="navbar-menu navbar-menu--top"
        v-if="
          [
            viewports.DESKTOP.name,
            viewports.WIDESCREEN.name,
            viewports.FULL_HD.name,
          ].includes(currentViewport)
        "
      >
        <div class="navbar-end"></div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { orderProcess } from "../../store/constants/order-process";
import { viewports } from "../../store/constants/viewports";
import SvgIcon from "../svg/SvgIcon";
import { eventBus } from "../../events/event-bus";
import LanguageSwitch from "../global/LanguageSwitch";
import BusinessCustomerSwitch from "../checkout/user-preferences/BusinessCustomerSwitch";

export default {
  name: "MainNavigation",
  components: { LanguageSwitch, SvgIcon, BusinessCustomerSwitch },
  data() {
    return {
      expanded: false,
      returnToCheckoutAfterClose: false,
      viewports: viewports,
    };
  },
  computed: {
    ...mapGetters([
      "screenSize",
      "currentViewport",
      "isCheckoutOpen",
      "cmsPage",
      "isUserLoggedIn",
      "allCartItems",
    ]),
    ...mapActions(["toggleCheckoutVisibility"]),
    mainNavigation() {
      if (this.cmsPage.page) {
        return this.cmsPage.page.navigation.main;
      }
      return null;
    },
    topNavigation() {
      if (this.cmsPage.page) {
        return this.cmsPage.page.navigation.top;
      }
      return null;
    },
    currentOrderProcessStep: {
      get() {
        return this.$store.getters["currentOrderProcessStep"];
      },
      set(orderProcessStep) {
        this.$store.dispatch("setCurrentOrderProcessStep", orderProcessStep);
      },
    },
    showUploadButton() {
      return (
        this.currentOrderProcessStep === orderProcess.STEPS.NO_ORDER_ONGOING ||
        this.currentOrderProcessStep === orderProcess.STEPS.ORDER_COMPLETED
      );
    },
  },
  methods: {
    resetOrderProcess() {
      this.currentOrderProcessStep = orderProcess.STEPS.NO_ORDER_ONGOING;
      this.$store.dispatch("clearCurrentCartItem");
      this.$router.push(
        `/${
          this.$i18n.locale.split("-")[0] !== "de"
            ? this.$i18n.locale.split("-")[0]
            : ""
        }`
      );
    },
    logout() {
      this.$store.dispatch("logoutUser");
      let route = this.$route.path;
      if (
        route === "/account" ||
        route === "/password-update" ||
        route === "/mail-update" ||
        route === "/profile-update" ||
        route.includes("/order-details")
      ) {
        this.$router.push("/");
      }
      eventBus.logout();
    },
    showFileUpload() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.currentOrderProcessStep = orderProcess.STEPS.FILE_UPLOAD;
      this.$store.dispatch("setCheckoutVisibility", true);
    },
    toggleMenu() {
      this.expanded = !this.expanded;
    },
    fetchCMSData() {
      this.$store.dispatch("fetchCMSPage", { urlSlug: this.$route.path });
    },
  },
  created() {
    this.$store.dispatch("fetchMainNavigation");
    this.$store.dispatch("fetchContentNavigation");
    this.$store.dispatch("fetchFooterNavigation");
    this.$store.dispatch("createCart");
  },
};
</script>

<style></style>
